import React from 'react'
import SubHeader from '../../../fragments/SubHeader';
import { useNavigate } from 'react-router-dom';
import BreadCrumbContainer from '../../../fragments/BreadCrumbContainer';
import BreadCrumb from '../../../fragments/BreadCrumb';

const SubHeaderDatosEnvio = () => {
    const navigate = useNavigate();
    return (
      <SubHeader>
        <BreadCrumbContainer>
          <BreadCrumb route={"Configuración del marketplace /"} onClick={() => navigate(`/marketplace/configuracion`)} />
          <BreadCrumb route={"Datos de envío"} active />
        </BreadCrumbContainer>
      </SubHeader>
    );
}

export default SubHeaderDatosEnvio